package com.fireavert.gateways.gateway_property_page.data_models.responses

import com.fireavert.gateways.shared.data_models.GatewayStatusModel
import kotlinx.serialization.Serializable

@Serializable
data class GatewaysStatusResponse(
    val gatewayStatus: List<GatewayStatusModel>
)